export default "__VITE_ASSET__1Ga2QfDb__"